<template>
  <v-row class="d-flex justify-center mt-0">
    <v-col cols="12">
      <!-- FILTROS -->
      <v-expansion-panels v-model="panel">
        <v-expansion-panel readonly>
          <v-btn
            style="position: absolute; top: -15px; right: 55px; z-index: 1"
            color="success"
            small
            fab
            @click="accion = null; dialog = true"
          >
            <v-icon>fas fa-plus</v-icon>
          </v-btn>
          <v-expansion-panel-header class="py-0 px-4 text-h5" style="cursor: default">
            <div>
              <v-icon class="mb-1" left>fas fa-filter</v-icon>
              Filtro
            </div>
            <template v-slot:actions>
              <v-btn icon @click.stop="panel = panel === 1 ? 0 : 1">
                <v-icon>fas fa-chevron-down</v-icon>
              </v-btn>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="pt-1">
            <v-form @submit.prevent="buscar()">
              <v-row>
                <v-col cols="5" sm="3" md="2" class="py-1">
                  Art. Código
                  <v-text-field
                    v-model.trim="filtro.articulo"
                    type="number"
                    hide-details
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="7" sm="4" md="3" class="py-1">
                  Nombre acción
                  <v-text-field
                    v-model.trim="filtro.nombre"
                    hide-details
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="5" md="3" class="py-1">
                  Marca
                  <v-autocomplete
                    v-model="filtro.marca"
                    item-text="nombre"
                    item-value="codigo"
                    :items="marcas"
                    hide-details
                    clearable
                    outlined
                    dense
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="8" md="4" class="py-1">
                  <v-row>
                    <v-col>
                      Fecha desde
                      <FechaPicker
                        v-model="filtro.desde"
                        hide-details
                      />
                    </v-col>
                    <v-col>
                      Fecha hasta
                      <FechaPicker
                        v-model="filtro.hasta"
                        hide-details
                      />
                    </v-col>
                  </v-row>
                </v-col>
                <BtnFiltro
                  :loading="load"
                  @clear="limpiar()"
                />
              </v-row>
            </v-form>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <!-- DATA TABLE -->
      <v-data-table
        class="cebra elevation-2 mt-2"
        sort-by="fecha_hasta"
        :custom-sort="customSort"
        :headers="headers"
        :items="acciones"
        :loading="load"
        :search="search"
        :item-class="itemRowBackground"
        mobile-breakpoint
        sort-desc
        dense
      >
        <template v-slot:top>
          <v-row class="d-flex justify-end pa-2" no-gutters>
            <v-col cols="6" sm="9" xl="10">
              <div class="d-flex">
                <download-excel
                  name="Acciones Marca.xls"
                  :fetch="getStock"
                >
                  <v-btn
                    title="Descargar Excel"
                    :x-small="$vuetify.breakpoint.xs"
                    :small="!$vuetify.breakpoint.xs"
                    :disabled="acciones.length == 0"
                  >
                    Excel
                    <v-icon
                      color="green darken-3"
                      :small="$vuetify.breakpoint.xs"
                      right
                    >
                      fas fa-file-download
                    </v-icon>
                  </v-btn>
                </download-excel>
              </div>
            </v-col>
            <v-col cols="6" sm="3" xl="2">
              <SearchDataTable
                v-model="search"
              />
            </v-col>
          </v-row>
        </template>
        <template v-slot:[`item.disponible`]="{ value }">
          {{ value < 0 ? 0 : value }}
          <v-icon
            v-if="value <= 3"
            color="orange"
            :title="`La cantidad vendida ${value <= 0  ? 'superó' : 'está próxima a superar'} el cupo. Verificar`"
            :class="`pulse-${$vuetify.theme.dark ? 'dark' : 'light'}`"
            small
          >
            fas fa-exclamation-triangle
          </v-icon>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-icon
            color="info"
            title="Ver"
            class="mr-2"
            small
            @click="accion = item; dialog = true"
          >
            fas fa-eye
          </v-icon>
          <BtnConfirmar
            icono="fas fa-trash"
            color="error"
            title="Eliminar"
            :texto="`¿Desea <strong>ELIMINAR</strong> la acción ${item.nombre}?<div style='margin-top: 8px'>(este accionar <strong>no se puede deshacer</strong>)</div>`"
            icon_button
            small
            @action="eliminar(item)"
          />
        </template>
        <template v-slot:no-data>
          <v-alert
            class="mx-auto mt-4"
            max-width="400"
            type="warning"
            border="left"
            dense
            text
          >
            No hay datos para los filtros seleccionados
          </v-alert>
        </template>
      </v-data-table>
    </v-col>
    <!-- COMPONENTES -->
    <AccionMarca
      v-model="dialog"
      :p_accion="accion"
      @editar="setAccion"
    />
  </v-row>
</template>

<script>
import { mapState } from 'vuex/dist/vuex.common.js'
import { nvl, parseDate } from '../../util/utils'
import BtnFiltro from '@/components/util/BtnFiltro.vue'
import FechaPicker from '@/components/util/FechaPicker.vue'
import BtnConfirmar from '@/components/util/BtnConfirmar.vue'
import SearchDataTable from '@/components/util/SearchDataTable.vue'
import AccionMarca from '@/components/auditoria/AccionMarca.vue'
import moment from 'moment'

export default {
  data () {
    return {
      moment: moment,
      nvl: nvl,
      panel: 0,
      load: false,
      dialog: false,
      search: '',
      headers: [
        { text: 'Id', value: 'id', align: 'right' },
        { text: 'Art. Código', value: 'articulo_codigo', align: 'right' },
        { text: 'Art. Nombre', value: 'articulo_nombre' },
        { text: 'Nombre acción', value: 'nombre' },
        { text: 'Cupo', value: 'cupo', align: 'center' },
        { text: 'Cant. vendida', value: 'cant_vendida', align: 'center' },
        { text: 'Disp.', value: 'disponible', align: 'left' },
        { text: 'Desde', value: 'fecha_desde' },
        { text: 'Hasta', value: 'fecha_hasta' },
        { text: 'Acciones', value: 'actions', sortable: false, filterable: false }
      ],
      acciones: [],
      accion: {},
      filtro: {
        articulo: null,
        nombre: null,
        marca: null,
        desde: null,
        hasta: null
      }
    }
  },
  async created () {
    this.$store.state.loading = true
    await this.$store.dispatch('marcas/get_marcas_habilitadas')
    this.$store.state.loading = false
  },
  computed: {
    ...mapState('marcas', ['marcas'])
  },
  components: {
    BtnFiltro,
    FechaPicker,
    BtnConfirmar,
    SearchDataTable,
    AccionMarca
  },
  methods: {
    async buscar () {
      this.accion = null
      this.acciones = []

      this.load = true
      let result = await this.$store.dispatch('accionMarca/getAcciones', this.filtro)
      this.load = false

      if (!result.exito) {
        this.$store.dispatch('show_snackbar', {
          text: result.message,
          color: 'error'
        })
        return
      }

      this.acciones = result.data
    },
    async eliminar (item) {
      this.$store.state.loading = true
      let result = await this.$store.dispatch('accionMarca/eliminarAccion', item.id)
      this.$store.state.loading = false

      if (result.exito == 1) {
        const index = this.acciones.indexOf(item)
        this.acciones.splice(index, 1)
        this.$store.dispatch('show_snackbar', {
          text: result.message,
          color: 'success'
        })
      } else {
        this.$swal.fire({
          title: result.message,
          icon: 'error'
        })
      }
    },
    async getStock () {
      this.$store.state.loading = true
      let result = await this.$store.dispatch('accionMarca/getStock', this.acciones.map(acc => acc.articulo_codigo))
      this.$store.state.loading = false

      if (!result.exito) {
        this.$store.dispatch('show_snackbar', {
          text: result.message,
          color: 'error'
        })
        return []
      }

      let data = []
      for (const accion of this.acciones) {
        let stock = result.data.find(rd => rd.articulo == accion.articulo_codigo)
        data.push({
          "Marca Id": accion.marca_id,
          "Marca Nombre": accion.marca_nombre,
          "Artículo Código": accion.articulo_codigo,
          "Artículo Nombre": accion.articulo_nombre,
          "Acción Id": accion.id,
          "Acción Nombre": accion.nombre,
          "Cupo": accion.cupo,
          "Cantidad Vendida": accion.cant_vendida,
          "Cantidad Disponible": accion.disponible,
          "Stock": stock ? stock.stock : 0,
          "Fecha Desde": accion.fecha_desde,
          "Fecha Hasta": accion.fecha_hasta,
          "Fecha Log": accion.fecha_log ? moment(accion.fecha_log).format('DD/MM/YYYY HH:mm:ss') : null,
          "Usuario Log": accion.usuario_log
        })
      }
      return data
    },
    customSort(items, sortBy, sortDesc) {
      if (!sortBy.length) return items
      
      return items.sort((a, b) => {
        // Comprobamos si se está ordenando por fecha
        if (sortBy[0] === 'fecha_desde' || sortBy[0] === 'fecha_hasta') {
          const dateA = new Date(parseDate(a[sortBy[0]]))
          const dateB = new Date(parseDate(b[sortBy[0]]))
          let sortResult = dateA - dateB
          return sortDesc[0] ? -sortResult : sortResult
        }
        
        // Ordenamiento por defecto para otros campos
        const sortA = a[sortBy[0]]
        const sortB = b[sortBy[0]]
        if (sortA < sortB) return sortDesc[0] ? 1 : -1
        if (sortA > sortB) return sortDesc[0] ? -1 : 1
        return 0
      })
    },
    itemRowBackground (item) {
      return this.accion != null && item.id == this.accion.id ? 'background-color: rowsel' : ''
    },
    setAccion (item) {
      let accion = this.acciones.find(acc => acc.id == item.id)
      Object.assign(accion, item)
    },
    limpiar () {
      this.accion = null
      this.filtro = {
        articulo: null,
        nombre: null,
        marca: null,
        desde: null,
        hasta: null
      }
    }
  }
}
</script>

<style>
.pulse-light {
  animation: pulse-light-animation 2s infinite;
  width: 10px;
  height: 10px;
  margin-left: 6px;
  margin-right: 12px;
  border-radius: 50%;
}

@keyframes pulse-light-animation {
  0% {
    box-shadow: 0 0 0 0px rgba(0, 0, 0, 0.2);
  }
  100% {
    box-shadow: 0 0 0 15px rgba(0, 0, 0, 0);
  }
}

.pulse-dark {
  animation: pulse-dark-animation 2s infinite;
  width: 10px;
  height: 10px;
  margin-left: 6px;
  margin-right: 12px;
  border-radius: 50%;
}

@keyframes pulse-dark-animation {
  0% {
    box-shadow: 0 0 0 0px rgba(255, 255, 255, 0.8);
  }
  100% {
    box-shadow: 0 0 0 15px rgba(0, 0, 0, 0);
  }
}
</style>